import React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { authSliceClearMessageForgotPassword } from "../../redux/slices/authSlice";
import RecoveryForm from "../../components/recovery/RecoveryForm.jsx";
import LeftImage from "../../components/login/LeftImage";

const Container = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authSliceClearMessageForgotPassword());
  }, [dispatch]);

  return (
    <div className="app">
      <LeftImage />
      <RecoveryForm />
    </div>
  );
};

export default Container;
